<template lang="pug">
div.animated.fadeIn
  b-card
    div.row
      div.col-sm-5
        h4.card-title.mb-0
          | Fallback String
        div.small.text-muted
          | Displaying string that triggered fallback intent
      //- div.col-sm-7.hidden-sm-down
      //-   b-btn.pull-right(type='button', variant='primary')
      //-     i.icon-cloud-download
      //-     | Export
    br
    fallback-table
</template>

<script>
export default {
  name: 'Fallback',
  data() {
    return {
    }
  },
  mounted: function() {
  },
}
</script>



// WEBPACK FOOTER //
// src/views/Fallback.vue?918b7bc2